export const css = {
	root: '_369qgIpG',
	header: 'o293rVBW',
	leading: 'U2VKeWDY',
	hero: 'Yj86T_It',
	close: '_1J1Bi03l',
	title: 'KHRE2mgz',
	skel: '_3AH5tdmO',
	success: '_1hMThHGn',
	intro: 'qpBxDe1t',
	badge: 'OlNPdKpY',
	' _key': 'explore-view/micro-view'
};

export default css;
